import { z } from "zod";

const TIME_ZONE_NAME_PATTERN = /^[A-Za-z][A-Za-z0-9_+\-/]{0,63}$/;

/** Removed in tzdata 2020b; ICU still accepts it, Postgres rejects it. */
const REMOVED_TIME_ZONE = "us/pacific-new";

function isKnownTimeZone(timeZone: string): boolean {
    if (timeZone.toLowerCase() === REMOVED_TIME_ZONE) {
        return false;
    }
    try {
        new Intl.DateTimeFormat("en-US", { timeZone });
        return true;
    } catch {
        return false;
    }
}

/**
 * An IANA time zone name such as "America/Los_Angeles", as browsers report
 * it. Only plain zone-name characters pass, and only names the runtime's
 * ICU knows, minus `US/Pacific-New`, which Postgres rejects. Not a strict
 * allowlist, since browser and Node ICU versions name some zones differently.
 */
export const ActivityTimeZoneSchema = z
    .string()
    .regex(TIME_ZONE_NAME_PATTERN)
    .refine(isKnownTimeZone, { message: "Unknown time zone" });
